import { User } from '@auth0/auth0-react';
import { useAppSelector, useEffect, useAppDispatch, useMemo } from 'hooks';
import { DataStatus } from 'types/enums';
import { ECGActions } from 'utils/store';

const usePatientData = (auth0User: User | undefined) => {
  const { data: userData } = useAppSelector(({ user }) => user);
  const { data: patientData, status: patientStatus } = useAppSelector(({ patient }) => patient);
  const { ecgCapture, status: ecgStatus } = useAppSelector(({ ecg }) => ecg);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userData?.patientId) {
      dispatch(ECGActions.getECGCapture(userData.patientId));
    }
  }, [dispatch, userData]);

  const patientECGData = useMemo(() => {
    if (ecgStatus === DataStatus.LOADING) {
      return { ...patientData, waveform: 'Loading...' };
    }

    const ecgData = ecgCapture ? ecgCapture.map((ecg) => ecg) : 'NA';

    return { ...patientData, waveform: ecgData };
  }, [patientData, ecgStatus, ecgCapture]);

  const firstName = userData?.firstName ?? auth0User?.name ?? 'Anonymous';
  const lastName = userData?.lastName ?? auth0User?.family_name ?? '';
  const fullName = `${firstName} ${lastName}`;

  return {
    patientFormattedData: [
      {
        ...patientECGData,
        firstName,
        lastName,
        fullName,
        avatarUri: auth0User?.picture,
        // TODO: refactor get by email endpoint on backend and use avatar uri here
      },
    ],
    isDataLoading: patientStatus === DataStatus.LOADING,
  };
};

export { usePatientData };
